module.exports = __webpack_public_path__ + "static/img/31.08acbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/31.png
// module id = Ve7H
// module chunks = 0